import { db } from '../../../config/firebaseconfig'
import firebase from 'firebase'

export default function devDeleteUserAssessment() {
  const testStudent = '67e46760-4193-11e8-b77a-099025fc2489'
  const assessmentId = '6e60eb20-172e-11e8-8bfb-cb0010808928'
  db.collection('students').doc(testStudent).get()
    .then((doc) => {
      const data = doc.data()
      const userAssessmentId = data.assessments[assessmentId].userAssessmentId
      return db.collection('userAssessments').doc(userAssessmentId).delete()
    })
    .then(() => {
      const key = `assessments.${assessmentId}`
      return db.collection('students').doc(testStudent).update({
        [key]: firebase.firestore.FieldValue.delete()
      })
    })
    .catch((err) => console.log(err))

}

// 67e46760-4193-11e8-b77a-099025fc2489 student id


// WEBPACK FOOTER //
// ./src/helpers/users/testing/deleteUserAssessment.js